import React from "react";
import "./index.scss";

export default function Section({ children, className = "", reference = null}) {
    return <section ref={reference} className={`section-container ${className}`}>
        {children}
    </section>
}